import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Close, Visibility } from "@mui/icons-material";

const GallerySection = ({ images, loading }) => {
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const itemsPerPage = 6;
  const totalPages = Math.ceil(images.length / itemsPerPage);
  const start = page * itemsPerPage;
  const currentImages = images.slice(start, start + itemsPerPage);

  const handleOpen = (index) => {
    setActiveIndex(start + index);
    setOpen(true);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <motion.article
      className="gallery-card ne-card"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
      viewport={{ once: true }}
    >
      <div className="gallery-header card-header">
        <span className="section-kicker">Gallery</span>
        <h3>Community Moments</h3>
      </div>

      <div className="gallery-grid premium">
        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <div className="gallery-item premium ne-skeleton" key={i} />
          ))}

        {!loading && currentImages.length === 0 && (
          <div className="home-empty-state">Gallery images will appear here soon.</div>
        )}

        {!loading &&
          currentImages.map((img, i) => (
            <motion.button
              key={img.id || `${img.title}-${i}`}
              type="button"
              className="gallery-item premium"
              whileHover={{ y: -6 }}
              onClick={() => handleOpen(i)}
            >
              <span className="gallery-image-wrap">
                <img src={img.image} alt={img.title || "Community moment"} />

                <span className="gallery-overlay">
                  <Visibility fontSize="small" />
                  View
                </span>
              </span>

              <span className="gallery-title">{img.title || "Community moment"}</span>
            </motion.button>
          ))}
      </div>

      {totalPages > 1 && (
        <div className="gallery-controls">
          <button
            type="button"
            aria-label="Previous gallery page"
            onClick={() => setPage((p) => Math.max(p - 1, 0))}
            disabled={page === 0}
          >
            <ChevronLeft fontSize="small" />
          </button>

          <span>
            {page + 1} / {totalPages}
          </span>

          <button
            type="button"
            aria-label="Next gallery page"
            onClick={() => setPage((p) => Math.min(p + 1, totalPages - 1))}
            disabled={page === totalPages - 1}
          >
            <ChevronRight fontSize="small" />
          </button>
        </div>
      )}

      {open && images[activeIndex] && (
        <div className="gallery-modal" role="dialog" aria-modal="true">
          <button
            className="gallery-close"
            type="button"
            aria-label="Close gallery"
            onClick={() => setOpen(false)}
          >
            <Close />
          </button>

          <button className="gallery-nav left" type="button" onClick={handlePrev}>
            <ChevronLeft />
          </button>

          <img
            src={images[activeIndex]?.image}
            alt={images[activeIndex]?.title || "Gallery preview"}
            className="gallery-modal-img"
          />

          <button className="gallery-nav right" type="button" onClick={handleNext}>
            <ChevronRight />
          </button>
        </div>
      )}
    </motion.article>
  );
};

export default GallerySection;
